import {useTranslation} from "react-i18next";
import {Row} from "react-bootstrap";
import {Icon} from "../components";
import React from "react";

export default function Error404(props) {
  const { t } = useTranslation();

  return (
    <>
      <Row style={{marginTop: "150px"}} className="justify-content-md-center">
        <div><Icon icon="exclamation" size="10x" variant="secondary"/></div>
      </Row>
      <Row className="justify-content-md-center">
        <div style={{marginTop: '50px', fontSize: '25px'}}>This page does not exist</div>
      </Row>
    </>
  )
}
